import React from 'react';
const OTPConfig = {
	settings: {
		layout: {}
	},
	routes: [
		{
			path: '/apps/otp-providers',
			component: React.lazy(() => import('./OTPProviders'))
		},
		{
			path: '/apps/otp-users',
			component: React.lazy(() => import('./OTPUsers'))
		}
	]
};

export default OTPConfig;
